import {
    applianceType,
    button,
    firmware,
    lastSeen,
    lastUpdate,
    reachable,
    zigBeeAddress
} from '~/helpers/fields-description';
import { DevicesModule } from '~/store/modules/devices';
import { LegrandModule } from './LegrandModule.model';

export class MultipleGangSwitch extends LegrandModule {

    get numberOfButtons(): number {
        // find all the devices that have the same root id to count the total number of buttons associated
        const id = this.id.split('#')[0];
        return DevicesModule.devices.filter((device) => device.id.includes(id)).length - 1;
    }

    get fieldApplianceType() {
        return applianceType(this.appliance_type);
    }
    get fieldId() {
        return undefined;
    }
    get fieldZigBeeAddress() {
        return zigBeeAddress(this.id);
    }
    get fieldSetupDate() {
        return undefined;
    }
    get fieldReachable() {
        return reachable(this.mainDevice?.reachable);
    }
    get fieldButton() {
        return button(this.id, this.numberOfButtons);
    }
    get fieldFirmware() {
        return firmware(this.mainDevice?.firmware);
    }
    get fieldLastUpdate() {
        return lastUpdate(this.mainDevice?.last_fw_update);
    }
    get fieldLastSeen() {
        return lastSeen(this.mainDevice?.last_seen, this.mainDevice?.reachable ? '' : 'error--text');
    }
    get fieldErgonomics() {
        return undefined;
    }
    get fieldPackaging() {
        return undefined;
    }
}
